<template>
  <v-card
    elevation="0"
    class="rounded-lg pa-0 w-100 h-100"
    style="overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Processing Time</h5>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col cols="6" class="d-flex mb-4">
          <BoxIconWithText
            color="red"
            icon=" mdi-timer-lock"
            title="Processing Time"
            :text="dataObj.processing_time"
          />
        </v-col>
        <!-- <v-col cols="6" class="d-flex mb-4">
          <BoxIconWithText
            color="orange"
            icon="mdi-timer-outline"
            title="Planned Processing Time"
            :text="dataObj.planned_processing_time"
          />
        </v-col> -->
        <v-col
          cols="6"
          class="d-flex mb-4"
          v-if="dataObj.actual_processing_time"
        >
          <BoxIconWithText
            color="blue"
            icon="mdi-timer-marker"
            title="Actual Processing Time"
            :text="dataObj.actual_processing_time"
          />
        </v-col>
        <v-col
          cols="6"
          class="d-flex mb-4"
          v-if="dataObj.estimated_processing_time"
        >
          <BoxIconWithText
            color="green"
            icon="mdi-timer-check"
            title="Estimated Processing Time"
            :text="dataObj.estimated_processing_time"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import BoxIconWithText from "@/components/BaseComponents/BoxIconWithText.vue";
export default {
  components: {
    BoxIconWithText,
  },
  props: {
    dataObj: {
      required: true,
    },
  },
};
</script>
